<template>
    <div class="fixed top-0 left-0 h-screen w-screen z-50 flex" style="background-color: rgba(0, 0, 0, .3);"
        v-if="overlayVisible" data-lenis-prevent>
        <div class="bg-white max-w-xl w-full max-h-screen overflow-y-auto m-auto rounded-lg">
            <div class="flex items-center justify-between mt-6 px-8 w-full">
                <p class="text-lg font-bold">Bankverbindungen</p>
                <button aria-label="Übersicht schließen"
                    class="flex items-center gap-2 p-3 hover:bg-gray-300 rounded-full text-sm" @click="toggle(false)">
                    <svg class="size-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>

                </button>
            </div>

            <div class="bg-primary-default mx-8 my-3 rounded-md flex flex-col p-3">
                <div class="flex gap-3 items-center">
                    <img src="@/assets/icons/info.png" class="invert h-6 mb-1" draggable="false">
                    <p class="font-bold text-white">Achtung!</p>
                </div>
                <p class="text-left text-white mt-5 px-1">
                    Bitte geben Sie bei Überweisungen im Verwendungszweck immer die RT-Nummer (Rechtsträger-Nummer) an.
                </p>
            </div>

            <div class="flex flex-col items-start text-left pb-4 px-8 mt-8">
                <div class="mb-8" v-for="i in banking">
                    <p class="font-bold underline">{{ i.name }}</p>
                    <div class="flex flex-col gap-1 mt-3">
                        <p class="flex"><span class="w-20 font-bold mr-8 shrink-0">Bank</span> {{ i.bank }}
                        </p>
                        <p class="flex"><span class="w-20 font-bold mr-8 shrink-0">Kontoinh.</span> {{ i.accountHolder }}</p>
                        <p class="flex"><span class="w-20 font-bold mr-8 shrink-0">IBAN</span> {{ i.iban }}</p>
                        <p class="flex" v-if="i.bic"><span class="w-20 font-bold mr-8 shrink-0">BIC</span> {{ i.bic }}</p>
                        <p class="flex"><span class="w-20 font-bold mr-8 shrink-0">RT</span> {{ i.rt }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import banking from "@/assets/data/banking.json"

export default {
    name: 'BankingOverlay',
    data() {
        return {
            overlayVisible: false,
            banking
        }
    },
    watch: {
        overlayVisible() {
            if (this.overlayVisible) {
                window.lenis.stop();
                document.querySelector('html').style.overflow = "hidden";
            } else {
                window.lenis.start();
                document.querySelector('html').style.overflow = "auto";
            }
        }
    },
    methods: {
        toggle(override = undefined) {
            this.overlayVisible = override || !this.overlayVisible;
        }
    },
    created() {
        // this.overlayVisible = true;
    }
}
</script>